import React from 'react';
import { OverlayComponent } from 'app/components';
import { validateExperienceTransfer } from '../utils/validate-experience-transfer';
import { ExperienceTransferContainerProps } from '../types';
import { ExperienceTransferStickyHeader } from './experience-transfer-sticky-header';

export const ExperienceTransferContainer: React.FC<ExperienceTransferContainerProps> = ({
  actionType, formState, shouldPrompt, translation, children,
  saveExperienceTransfer, deleteExperienceTransfer, updateValidation, displayError
}) => {

  const { experienceTransferItem, fetching, saving, deleting, validation } = formState;

  const onSave = () => {
    const formValidation = validateExperienceTransfer(experienceTransferItem, translation);

    updateValidation({ ...validation, ...formValidation });

    if (Object.keys(formValidation).length > 0) {
      displayError(translation.experience_transfer_validation_error);
      return;
    }

    saveExperienceTransfer(experienceTransferItem);
  };

  const experienceTransferName = [
    experienceTransferItem?.subscriberGroup?.description ?? '',
    experienceTransferItem?.criteria?.description ?? '',
    experienceTransferItem?.caseType?.description ?? '',
    experienceTransferItem?.operation?.description ?? '',
    !experienceTransferItem?.active ? translation.inactive : ''
  ].filter(Boolean).join(' | ');

  return <>
    <OverlayComponent
      displayOverlay={saving || deleting}
      overlayText={saving
        ? translation.saving_experience_transfer
        : translation.deleting_experience_transfer} />
    <ExperienceTransferStickyHeader
      actionType={actionType}
      shouldPrompt={shouldPrompt}
      experienceTransferItem={experienceTransferItem}
      name={experienceTransferName}
      fetching={fetching}
      displayError={displayError}
      onSave={onSave}
      onDelete={deleteExperienceTransfer}
      translation={translation} />
    {children}
  </>;
};
